<template>
    <div class="row">
        <div class="col" v-if="isLoading">
            <card>
                 <span slot="header">
                  </span>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                 spin></font-awesome-icon></span></h1>
                <div slot="footer">
                </div>
            </card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4" v-if="!isLoading" v-for="ivr in ivrs"
             :key="ivr.name">
            <IVRCard :initialIVR="ivr" v-on:button-add="loadIVRS" v-on:button-remove="loadIVRS"
                     v-on:remove="" v-on:save=""></IVRCard>
        </div>

    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";
    import swal from 'sweetalert2';
    import IVRCard from "./IVRCard";

    export default {
        name: "IVRGrid",
        components: {
            IVRCard,
            swal,
        },
        computed: {
            ...mapFields(`sipdevice`, ['sipdevices']),
            ...mapFields(`ivr`, ['ivrs']),
        },
        data() {
            return {
                isLoading: false,
                inputVisible: false,
                inputValue: [],
                removing: [],
                showCreateModal: false,
                showAddButtonModal: false,
                selectedIVR: null,
            };
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            save(gIndex) {
                this.saving.splice(gIndex, 1, true);
                let data = this.callgroups[gIndex];
                let name = this.names[gIndex];
                this.$store.dispatch('callgroup/save', {name, data}).then(() => {
                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: 'Your callgroup: ' + data.name + ' was saved!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Saved!"
                    });

                    this.dirty.splice(gIndex, 1, false);
                    this.saving.splice(gIndex, 1, false);
                    this.names.splice(gIndex, 1, this.callgroups[gIndex].name);
                }).catch(() => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Your callgroup: ' + data.name + ' failed to save!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });

                    this.saving.splice(gIndex, 1, false);
                });
            },
            handleNameInputChange(gIndex, value) {
                let name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
                this.$store.commit('callgroup/UPDATE_CALLGROUP_NAME', {gIndex, name});
                this.dirty.splice(gIndex, 1, true);
            },
            loadIVRS() {

                if (this.$store.getters['ivr/needUpdate']) {
                    this.isLoading = true;
                    this.$store.dispatch('ivr/load').then(() => {
                        this.localIVRs = this.ivrs;
                        this.dirty = [];
                        this.names = [];
                        this.saving = [];
                        this.localIVRs.forEach(g => {
                            this.dirty.push(false);
                            this.names.push(g.name);
                            this.saving.push(false);
                        });
                        this.isLoading = false;
                    })
                }
            },
            loadDIDsAndIVRs() {
                this.$store.dispatch('callflow/loadAll');
                this.loadIVRS();
            }

        },
        mounted() {
            if (this.$store.getters['sipdevice/needUpdate']) {
                this.$store.dispatch('sipdevice/loadSIPDevices');
            }
            this.loadIVRS();
        },
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
